import { ChangeEvent } from 'react';

import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../../store/hooks';
import { FiltersPayloadModel } from '../../models/filters-payload.model';

export const useInputHandlerEvent = <TPayload>(
  prop: keyof TPayload,
  dispatchAction: ActionCreatorWithPayload<FiltersPayloadModel<TPayload>>
): ((event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void) => {
  const dispatch = useAppDispatch();
  return (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const nameFilter: FiltersPayloadModel<TPayload> = {
      property: prop,
      filterValue: event?.target?.value,
    };
    dispatch(dispatchAction(nameFilter));
  };
};
